import { isDefined } from '@sgme/fp';
import type { FormErrorSeverity } from 'models/formError';
import type { OrderValidation } from 'state/secondaryMarket/shared/amend/amend.model';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';

export function toValidationErrors(validations?: OrderValidation[] | null | undefined) {
  if (!isDefined(validations)) {
    return [];
  }
  return validations.filter(({ level, message }) => isDefined(level) && isDefined(message)).map(mapValidation);
}

function mapValidation(validation: OrderValidation): SecondaryMarketFormError {
  return {
    fields: [],
    severity: getValidationLevel(validation.level!),
    values: {},
    message: validation.message!,
  };
}

function getValidationLevel(validation: string): FormErrorSeverity {
  switch (validation) {
    case 'WARN':
      return 'Warning';
    case 'ERROR':
      return 'Error';
  }
  return 'Warning';
}
